var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.shouldShowSavings)?_c('div',{staticClass:"pd-Savings_Wrapper"},[_c('div',{staticClass:"pd-Show_SalesPercent h5 mb-0"},[_vm._v("-"+_vm._s(_vm.savings)+" %")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }